export const regenerateMenuStyles = {
  settingsHint: 'max-w-64 cursor-pointer text-xs text-muted-foreground',
  settingsLink: 'font-medium text-primary underline underline-offset-2',
};
